'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _EnterpriseModal = require('../EnterpriseModal');

var _EnterpriseModal2 = _interopRequireDefault(_EnterpriseModal);

var _EnterpriseButton = require('../EnterpriseButton');

var _EnterpriseButton2 = _interopRequireDefault(_EnterpriseButton);

var _EnterpriseRules = require('./EnterpriseRules.scss');

var _EnterpriseRules2 = _interopRequireDefault(_EnterpriseRules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseRules = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseRules, _Component);

  function EnterpriseRules() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnterpriseRules);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnterpriseRules.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseRules)).call.apply(_ref, [this].concat(args))), _this), _this.onCancel = function (event, extra) {
      if (_this.props.onCancel) _this.props.onCancel(event, extra);
    }, _this.onConfirm = function (event, extra) {
      if (_this.props.onConfirm) _this.props.onConfirm(event, extra);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnterpriseRules, [{
    key: '_getClassNames',
    value: function _getClassNames(element) {
      var _cx;

      var _props = this.props,
          isBasic = _props.isBasic,
          isStatic = _props.isStatic;


      return (0, _classnames2.default)(this.props[element + 'ClassName'], (_cx = {}, (0, _defineProperty3.default)(_cx, _EnterpriseRules2.default[element], _EnterpriseRules2.default[element]), (0, _defineProperty3.default)(_cx, _EnterpriseRules2.default[element + '--static'], _EnterpriseRules2.default[element] && isStatic), (0, _defineProperty3.default)(_cx, _EnterpriseRules2.default[element + '--basic'], _EnterpriseRules2.default[element] && isBasic), _cx));
    }
  }, {
    key: '_getClassesNames',
    value: function _getClassesNames() {
      return {
        backdropClassName: this._getClassNames('backdrop'),
        dialogClassName: this._getClassNames('dialog'),
        headerClassName: this._getClassNames('header'),
        footerClassName: this._getClassNames('footer'),
        bodyClassName: this._getClassNames('body')
      };
    }

    /* RENDERERS
    ----------------------------------------------------------------------------------------------- */

  }, {
    key: '_renderHeader',
    value: function _renderHeader() {
      return 'Rules Configuration';
    }
  }, {
    key: '_renderFooter',
    value: function _renderFooter() {
      var _props2 = this.props,
          confirmText = _props2.confirmText,
          cancelText = _props2.cancelText,
          confirmHidden = _props2.confirmHidden,
          cancelHidden = _props2.cancelHidden;


      return _react2.default.createElement(
        'div',
        null,
        /* CONFIRM */
        (!confirmHidden || null) && _react2.default.createElement(
          _EnterpriseButton2.default,
          {
            className: _EnterpriseRules2.default.confirmBtn,
            type: _EnterpriseButton.TYPES.PRIMARY,
            size: _EnterpriseButton.SIZES.MEDIUM,
            onClick: this.onConfirm
          },
          confirmText
        ),
        /* CANCEL */
        (!cancelHidden || null) && _react2.default.createElement(
          _EnterpriseButton2.default,
          {
            className: _EnterpriseRules2.default.cancelBtn,
            type: _EnterpriseButton.TYPES.SECONDARY,
            size: _EnterpriseButton.SIZES.MEDIUM,
            onClick: this.onCancel
          },
          cancelText
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          body = _props3.body,
          header = _props3.header,
          footer = _props3.footer,
          rest = (0, _objectWithoutProperties3.default)(_props3, ['children', 'body', 'header', 'footer']);

      var _header = header || this._renderHeader();
      var _footer = footer || this._renderFooter();
      return _react2.default.createElement(
        _EnterpriseModal2.default,
        (0, _extends3.default)({}, rest, this._getClassesNames(), { footer: _footer }),
        children || body
      );
    }
  }]);
  return EnterpriseRules;
}(_react.Component), _class.propTypes = {
  isOpen: _react.PropTypes.bool.isRequired,
  onCancel: _react.PropTypes.func.isRequired,
  onConfirm: _react.PropTypes.func,

  children: _react.PropTypes.node,

  isStatic: _react.PropTypes.bool,
  isBasic: _react.PropTypes.bool,
  autoWrap: _react.PropTypes.bool,
  keyboard: _react.PropTypes.bool,

  transitionName: _react.PropTypes.string,
  transitionDuration: _react.PropTypes.number,

  header: _react.PropTypes.node,
  footer: _react.PropTypes.node,
  body: _react.PropTypes.node, // Alternative to children, children has priority

  // IGNORED IF FOOTER IS SENT
  confirmText: _react.PropTypes.string,
  cancelText: _react.PropTypes.string,
  confirmHidden: _react.PropTypes.bool,
  cancelHidden: _react.PropTypes.bool,

  backdropClassName: _react.PropTypes.string,
  dialogClassName: _react.PropTypes.string,
  headerClassName: _react.PropTypes.string,
  footerClassName: _react.PropTypes.string,
  bodyClassName: _react.PropTypes.string
}, _class.defaultProps = {
  autoWrap: true,
  keyboard: true,
  isStatic: false,
  isBasic: true,

  confirmText: 'OK',
  cancelText: 'CANCEL'
}, _temp2);
exports.default = EnterpriseRules;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseRules/EnterpriseRules.jsx
// module id = 1608
// module chunks = 0